import Sonda from '@gc-npm/utils.monitoring.sonda';
import getUUID from '@gc-npm/utils.monitoring.get-uuid';
import Request from '@gc-npm/utils.fetch';
import { calculateHeaderParams } from '@gc-npm/node.build-process.build-environments';
import { FAMILY_API } from '@gc-npm/utils.enums.environment';
import { normalizeUserBundle } from '@gc-npm/adabyron.ssr.config-tv.init';

const METHOD = 'GET';
const PATH = '/api/v1/config-controller/init';
const EVENT_NAME = {
  CLIENT: 'SSR_CONFIG.INIT_CLIENT',
  OPEN: 'SSR_CONFIG.INIT',
};

export const init = ({
  context,
  build = null,
  onSuccess,
  idFront = 'TC',
  urlParams,
  clientInfo,
  mainInfo,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: context.userType ? EVENT_NAME.CLIENT : EVENT_NAME.OPEN,
    context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API',
  });
  try {
    const { 'ssr-backend': connectionData, name } = context.environment;
    let { endpoint: host } = connectionData;
    if (name === 'local' && !build) {
      // mientras desarrollamos
      host = 'http://127.0.0.1:8080';
      // host = 'https://ssr.col.movistar.es';
    }
    const headers2Use = calculateHeaderParams(build, FAMILY_API.SSR_BACKEND, context);

    let params = '';
    let normalizedClientInfo = clientInfo;
    let sessionZone = mainInfo?.zone || null;

    if (mainInfo) {
      normalizedClientInfo = normalizeUserBundle(mainInfo);
      normalizedClientInfo.promotions = {
        ...normalizedClientInfo.promotions,
        targetAudience: Array.isArray(mainInfo.userPromotions?.targetAudience)
          ? mainInfo.userPromotions.targetAudience
          : [],
      };
    }
    
    if (normalizedClientInfo) {
      sessionZone = normalizedClientInfo.productZoneId || sessionZone;
      const clientInfoParam = encodeURIComponent(JSON.stringify(normalizedClientInfo));
      params += `&clientInfo=${clientInfoParam}`;
    }
    if (sessionZone) {
      params += `&sessionZone=${sessionZone}`;
    }
    if (urlParams?.debugServer) {
      params += `&urlParamsDebug=${urlParams.debugServer}`;
    }
    if (urlParams?.enviromentQa) {
      params += `&enviromentQa=${urlParams.enviromentQa}`;
    }
    if (urlParams?.rehidratate) {
      params += `&rehidratate=${urlParams.rehidratate}`;
    }
    if (String(urlParams?.includeHiredMobileAddons) === 'true') {
      params += '&includeHiredMobileAddons=true';
    }

    const URL_API = `${host}${PATH}?${idRequest}${params}`;
    const request = new Request({
      method: METHOD,
      endpoint: URL_API,
      data: '',
      build,
      headers: {
        ...headers2Use,
      },
      onError: () => {
        return null;
      },
      sonda,
      onSuccess: (response) => {
        return onSuccess({ response });
      },
    });
    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return err;
  }
};

export default init;
